// App.js (updated)
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useParams, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import ForgotPassword from './components/Auth/ForgotPassword';
import Dashboard from './components/Dashboard/Dashboard';
import PdfViewer from './components/PdfViewer';
import Header from './components/Header'; // <--- ADD THIS LINE HERE
import Home from './Home'; // ADD THIS IMPORT
import './App.css';

// PDF Viewer wrapper that uses URL parameters
function PdfViewerWrapper() {
  const { title } = useParams();
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="App">
      <PdfViewer
        documentTitle={title}
        onBackToDashboard={handleBackToDashboard}
      />
    </div>
  );
}

// Main app content that uses the auth context
function AppContent() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginSuccess = (userData) => {
    console.log("🎉 Login successful, user set:", userData.name);
    navigate('/dashboard');
  };

  const handleSignupSuccess = (userData) => {
    console.log("🎉 Signup successful, user set:", userData.name);
    navigate('/dashboard');
  };

  const handleViewPdf = (pdfId, pdfTitle) => {
    const urlSafeTitle = encodeURIComponent(pdfTitle);
    navigate(`/pdf/${urlSafeTitle}`);
    console.log('Opening PDF viewer for:', pdfId, pdfTitle);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="App">
      <Routes>
        {/* Home Page - Accessible to everyone */}
        <Route path="/" element={<Home />} />

        {/* Auth Routes - Redirect to dashboard if already logged in */}
        <Route
          path="/login"
          element={
            currentUser ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login
                switchToSignup={() => navigate('/signup')}
                onLoginSuccess={handleLoginSuccess}
                showForgotPassword={() => navigate('/forgot-password')}
              />
            )
          }
        />
        <Route
          path="/signup"
          element={
            currentUser ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Signup
                switchToLogin={() => navigate('/login')}
                onSignupSuccess={handleSignupSuccess}
              />
            )
          }
        />
        <Route
          path="/forgot-password"
          element={
            currentUser ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <ForgotPassword
                switchToLogin={() => navigate('/login')}
              />
            )
          }
        />

        {/* Protected Routes - Require authentication */}
        {currentUser ? (
          <>
            <Route
              path="/dashboard"
              element={
                <div className="App">
                  <Header user={currentUser} onLogout={handleLogout} />
                  <Dashboard onViewPdf={handleViewPdf} />
                </div>
              }
            />
            <Route path="/pdf/:title" element={<PdfViewerWrapper />} />
          </>
        ) : (
          <Route path="/dashboard" element={<Navigate to="/login" replace />} />
        )}

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

// Main App component that provides the auth context and router
function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;